import React, { useRef, useState } from 'react';
import { AutoComplete, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { canSee } from '../utils/roles';

/** Google-like search across horse number, name, nickname, chip, passport, owner, box, breed, notes. */
export default function HorseSearch({ wide }) {
  const navigate = useNavigate();
  const [opts, setOpts] = useState([]);
  const [text, setText] = useState('');
  const timer = useRef();
  if (!canSee('/horses')) return null;

  const search = (q) => {
    setText(q);
    clearTimeout(timer.current);
    if (!q || q.trim().length < 2) { setOpts([]); return; }
    timer.current = setTimeout(async () => {
      try {
        const rows = (await api.get('/horses/search/', { params: { q } })).data || [];
        setOpts(rows.map((h) => ({
          value: String(h.id),
          label: (
            <div>
              <b>{h.horse_name}</b>
              {h.nickname ? <span style={{ color: '#8c6b4a' }}> · {h.nickname}</span> : null}
              <span style={{ color: '#888' }}> · No. {h.horse_no}</span>
              <div style={{ fontSize: 12, color: '#888' }}>
                {[h.owner, h.box, h.chip && `chip ${h.chip}`].filter(Boolean).join(' · ')}
              </div>
            </div>
          ),
        })));
      } catch {
        setOpts([]);
      }
    }, 250);
  };

  return (
    <AutoComplete
      style={{ width: wide ? '100%' : 260, maxWidth: wide ? 360 : 260 }}
      value={text}
      options={opts}
      onSearch={search}
      onChange={setText}
      onSelect={(id) => { setText(''); setOpts([]); navigate(`/horses/${id}`); }}
      notFoundContent={text.trim().length >= 2 ? 'No horse found' : null}
    >
      <Input prefix={<SearchOutlined />} allowClear placeholder="Search horses (name, nickname, no., chip…)" />
    </AutoComplete>
  );
}
